import { render, staticRenderFns } from "./SubUser.vue?vue&type=template&id=559b83cd&scoped=true"
import script from "./SubUser.vue?vue&type=script&lang=js"
export * from "./SubUser.vue?vue&type=script&lang=js"
import style0 from "./SubUser.vue?vue&type=style&index=0&id=559b83cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b83cd",
  null
  
)

export default component.exports